module.exports = __webpack_public_path__ + "static/media/ico-plan.1f18bd84.svg";